import { createBrowserClient } from '@supabase/ssr'

// Singleton pattern to ensure we don't initialize multiple clients
let supabaseInstance: ReturnType<typeof createBrowserClient> | null = null

// Initialize the Supabase client with enhanced error handling
export const createClient = () => {
  if (supabaseInstance) return supabaseInstance

  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
  const supabaseKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  if (!supabaseUrl || !supabaseKey) {
    console.error('Supabase credentials are missing. Check your environment variables.')
  }

  try {
    supabaseInstance = createBrowserClient(
      supabaseUrl ?? '',
      supabaseKey ?? '',
      {
        // Set custom auth behavior
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true
        }
      }
    )
    return supabaseInstance
  } catch (error) {
    console.error('Error initializing Supabase client:', error)
    throw error
  }
}